import axios from 'axios';

class customerService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    getCustomer(customerId) {
        return axios
            .get(this.state.apiUrl + 'admin/viewCustomer?customerId=' + customerId, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    getCustomers(searchKey, searchBy) {
        const search = searchBy === 'Company' ? 'searchCompany' : 'searchBranch';
        const url = this.state.apiUrl + 'admin/' + search + '?name=' + searchKey;
        if (url.includes(this.state.apiUrl + 'admin/' + search + '?name=' + searchKey)) {
            return axios
                .get(url)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    deleteCustomer(customerId) {
        return axios
            .delete(this.state.apiUrl + 'admin/deleteCustomer/' + customerId)
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    saveOrUpdateCustomer(params) {
        if (params.customerId) {
            return axios
                .put(this.state.apiUrl + 'admin/updateCustomer', JSON.stringify(params))
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        } else {
            return axios
                .post(this.state.apiUrl + 'admin/saveCustomer', JSON.stringify(params))
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }
    refreshCustomer(params) {
        return axios
            .post(this.state.apiUrl + 'admin/refreshCustomer', JSON.stringify(params))
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    searchUserByCustomerId(searchKey, customerId) {
        const search = 'searchUserByCustomerId';
        const url = this.state.apiUrl + 'admin/' + search + '?name=' + searchKey + '&customerId=' + customerId;
        if (url.includes(this.state.apiUrl + 'admin/' + search + '?name=' + searchKey + '&customerId=' + customerId)) {
            return axios
                .get(url)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getUser(companyId) {
        return axios
            .get(this.state.apiUrl + 'home/listUsersByCompanyId?companyId=' + companyId, { silent: true })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                return err;
            });
    }

    updateCustomerPGP(params) {
        if (params.customerId) {
            return axios
                .put(this.state.apiUrl + 'admin/updateCustomerPGP', JSON.stringify(params))
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }
}

export default customerService;
